"use client";

import { GoogleTagManagerNoScript } from "@/components/common/GoogleTagManager";

export default function Analytics() {
  return <GoogleTagManagerNoScript />;
}
